const BASE_URL = "/master-data/general-posting-group";

export default [
  {
    path: `${BASE_URL}/general-business-posting-group`,
    name: "GeneralBusinessPostingGroupIndex",
    component: () => import("@/pages/masterData/generalBusinessPostingGroup/Index.vue"),
  },
  {
    path: `${BASE_URL}/general-product-posting-group`,
    name: "GeneralProductPostingGroupIndex",
    component: () => import("@/pages/masterData/generalProductPostingGroup/Index.vue"),
  },
  {
    path: `${BASE_URL}/inventory-posting-group`,
    name: "InventoryPostingGroupIndex",
    component: () => import("@/pages/masterData/inventoryPostingGroup/Index.vue"),
  },
  {
    path: `${BASE_URL}/bank-account-posting-group`,
    name: "BankAccountPostingGroupIndex",
    component: () => import("@/pages/masterData/bankAccountPostingGroup/Index.vue"),
  },
  {
    path: `${BASE_URL}/deposit-account-posting-group`,
    name: "DepositAccountPostingGroupIndex",
    component: () => import("@/pages/masterData/depositAccountPostingGroup/Index.vue"),
  },
  {
    path: `${BASE_URL}/client-posting-group`,
    name: "ClientPostingGroupIndex",
    component: () => import("@/pages/masterData/clientPostingGroup/Index.vue"),
  },
  {
    path: `${BASE_URL}/vendor-posting-group`,
    name: "VendorPostingGroupIndex",
    component: () => import("@/pages/masterData/vendorPostingGroup/Index.vue"),
  },
];